module.exports = __webpack_public_path__ + "img/Panorama_Heron_1.29d362bd.webp";